import React from 'react';
import Modal from 'react-modal';
import { translate } from '../Services/translation';



const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
    overlay: {       
        zIndex: 1000,
    },
  };
const SiteModal = ({ content, ContentType }) => {

  
    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }


    function closeModal() {
        setIsOpen(false);
    }

    return (
        content && (
            <div>
                <button className='site-modal__open' onClick={openModal}>{translate('sizeguide.button.text')}</button>
                <Modal
                    isOpen={modalIsOpen}                   
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Sizeguide Modal"
                    ariaHideApp={false}
                >
                    <h2 className='site-modal__title'>{translate('sizeguide.modal.title')}</h2>
                    <button className='site-modal__close' onClick={closeModal}></button>
                    <div><img alt="" src={content} /></div>
                  
                </Modal>
            </div>
        )
    );
};

export default SiteModal;
